
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M10.98 1.71c1.806 4.329 5.502 6.932 7.769 8.19-.976.312-2.174.87-3.396 1.869-1.602 1.309-3.215 3.35-4.43 6.511-1.468-5.38-1.395-11.212.057-16.57zM6.428 6.982c-.302 2.398-.216 4.521.187 6.98-1.239-1.316-2.872-2.694-4.69-3.673a8.102 8.102 0 002.84-1.521C5.377 8.26 5.917 7.66 6.429 6.98z","stroke":"currentColor","stroke-width":"1.4"}})])
          )
        }
      }
    